var render = function render(){var _vm=this,_c=_vm._self._c;return _c('gl-button',{attrs:{"icon":"tanuki-ai","loading":_vm.isEnabling,"category":"tertiary","size":"small","data-testid":"work-item-plan-cta"},on:{"click":_vm.enableAiPlanning}},[_vm._v("\n  "+_vm._s(_vm.s__('WorkItem|Plan'))+"\n")])
}
var staticRenderFns = []

export { render, staticRenderFns }